export default __webpack_public_path__ + "static/media/39.4c99e0fe.jpeg";